import { gsap } from "gsap";

export const initTlBox = () => {
  const Box = document.getElementById("box1");
  if (Box) {
    // Create and configure the timelines

    gsap.set(".box_G3", { scale: 0.8 });
    gsap.set("#box1", { y: 0 });
    gsap.to(".gift", { y: "0", scale: 0.2 });
    gsap.to(".priceDisplayContent", { opacity: 1 });

    const tl_lockup_Box = gsap.timeline({ repeat: 0, paused: true });


    tl_lockup_Box
      .from(".box_G", { scale: 0, duration: 2, ease: "elastic.out(1, 0.25)", delay: 0.0 })
      .to(".box_G2", { transformOrigin: "50% 100%", scaleY: 0.9, scaleX: 1.1, duration: 0.5, ease: "power1.inOut" }, "-=0.5")
      .to(".box_G2", { transformOrigin: "50% 100%", scaleY: 1.2, scaleX: 0.9, duration: 0.4, ease: "power1.inOut" }, "-=0.0")
      .to(".box_G2", { transformOrigin: "50% 100%", scaleY: 1, scaleX: 1, duration: 0.2, ease: "power1.inOut" }, "-=0.0")
      .to("#box1", { y: "-=120%", duration: 1, ease: "elastic.out(1, 0.5)" }, "-=0.6")
      .to(".gift", { y: "-=83%", scale: 1, duration: 1.5, ease: "elastic.out(1, 0.5)" }, "-=0.8")
      .from("#lovely", { scale: 0, duration: 2, ease: "elastic.out(1, 0.25)" }, "-=1.0")
      .from("#lovely_copy", { y: 10, opacity: 0, duration: 2, ease: "elastic.out(1, 0.25)" }, "-=1.7")
      .from("#btn2_G", { scale: 0, duration: 2, ease: "elastic.out(1, 0.25)" }, "-=1.9")
      .eventCallback("onComplete", () => {
        gsap.to(".box_G3", {
          scale: 0.85,
          duration: 1.5,
          ease: "power1.inOut",
          yoyo: true,
          repeat: -1
        });
      });

    const tl_lockup_Box2 = gsap.timeline({ repeat: 0, paused: true });

    tl_lockup_Box2
      .to(".cG", { opacity: 1, duration: 0.01 }, "0")
      .from("#c1", { scale: 1.2, y: "-100%", duration: 3, ease: "power1.inOut" }, "0")
      .from("#c2", { scale: 1.3, y: "-100%", duration: 3, ease: "power1.inOut" }, "-=2.8")
      .from("#c3", { scale: 1.4, y: "-100%", duration: 3, ease: "power1.inOut" }, "-=2.8")
      .from("#c4", { scale: 1.2, y: "-100%", duration: 3, ease: "power1.inOut" }, "-=2.8")
      .from("#c5", { scale: 1.3, y: "-100%", duration: 3, ease: "power1.inOut" }, "-=2.8");

    const tl_yoyo_Box = gsap.timeline({ repeat: -1, yoyo: true });
    tl_yoyo_Box.fromTo(".box_G img", 
      { filter: "blur(0px) brightness(1) drop-shadow(0 0 20px rgba(255, 255, 255, 0.2))" },
      { filter: "blur(1px) brightness(1) drop-shadow(0 0 50px rgba(255, 255, 255, 1))", duration: 0.9, ease: "power1.inOut" });

    // Play the timelines
    tl_lockup_Box.play();
    tl_lockup_Box2.play();

  } else {
    // Retry after 100ms if the element is not found
    setTimeout(initTlBox, 100);
  }
};
